module.exports = __webpack_public_path__ + "img/item3bagvideo.f2604235.png";